import React from "react";
import { itemStyle } from "../constants";
import APVMAIcon from "../static/APVMAIcon.png";

export const Apvma = ({ handleConnect }) => {
  return (
    <>
      <div style={itemStyle} className="bg-white p-7 mt-10">
        <div className="text-center mb-14">
          <img src={APVMAIcon} alt="logo" />
        </div>
        <h3 className="mb-2 text-dark">
          <strong>APVMA</strong>
        </h3>
        <div style={{ fontSize: "14px" }}>
          This integration connects the AgSafe platform to APVMA.
        </div>
        <div className="mt-25">
          <button
            className="text-uppercase border-0 bg-transparent text-secondary font-weight-bold"
            disabled
          >
            Connect
          </button>
        </div>
      </div>
    </>
  );
};
